import { START, SUCCESS, ERROR } from '../../constants/action-postfix'
import { call, put, takeLatest, select } from 'redux-saga/effects'
import { authAPI } from './../../api/auth'
import { startSubmit, stopSubmit } from 'redux-form'
import { NotificationManager } from 'react-notifications'
import { MAX_RETRIES } from '../../constants/api'


const AUTH_REQUEST = 'AUTH_REQUEST'
const CHECK_AUTH_REQUEST = 'CHECK_AUTH_REQUEST'
const RESET_AUTH_DATA = 'RESET_AUTH_DATA'
const RESET_AUTH_DATA_ACTION = 'RESET_AUTH_DATA_ACTION'
const GET_REPORTS_ACCESS_LIST = 'GET_REPORTS_ACCESS_LIST'

const initialState = {
  data:
    localStorage.getItem('login') && localStorage.getItem('pass')
      ? {
          login: localStorage.getItem('login'),
          pass: localStorage.getItem('pass'),
        }
      : undefined,
  reports_access: localStorage.getItem('reports_access') ? JSON.parse(localStorage.getItem('reports_access')) : null,
  error: null,
}

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_AUTH_DATA:
      return {
        data: undefined,
        error: null,
      }

    case `${AUTH_REQUEST}${SUCCESS}`:
      return {
        data: action.payload,
        error: null,
      }

    case `${CHECK_AUTH_REQUEST}${SUCCESS}`:
      return {
        data: action.payload,
        error: null,
      }

    case `${AUTH_REQUEST}${ERROR}`:
      return {
        data: null,
        error: action.payload,
      }

    case `${CHECK_AUTH_REQUEST}${ERROR}`:
      return {
        data: null,
        error: null,
      }

    case `${GET_REPORTS_ACCESS_LIST}${SUCCESS}`:
      return {
        ...state,
        reports_access: action.payload,
      }

    case `${GET_REPORTS_ACCESS_LIST}${ERROR}`:
      return {
        ...state,
        reports_access: null,
      }

    default:
      return state
  }
}

// ACTIONS

export const authRequestStart = (login, pass) => ({
  type: `${AUTH_REQUEST}${START}`,
  payload: { login, pass },
})

export const authRequestSuccess = (data, authData) => ({

  type: `${AUTH_REQUEST}${SUCCESS}`,
  payload: { ...data, ...authData },
})

export const authRequestError = data => ({
  type: `${AUTH_REQUEST}${ERROR}`,
  payload: data,
})

export const resetAuthData = () => ({
  type: RESET_AUTH_DATA,
})

export const resetAuthDataAction = () => ({
  type: RESET_AUTH_DATA_ACTION,
})

export const checkAuthRequestStart = () => ({
  type: `${CHECK_AUTH_REQUEST}${START}`,
})

export const checkAuthRequestSuccess = data => ({
  type: `${CHECK_AUTH_REQUEST}${SUCCESS}`,
  payload: data,
})

export const checkAuthRequestError = data => ({
  type: `${CHECK_AUTH_REQUEST}${ERROR}`,
  payload: data,
})

export const getReportsAccessListStart = () => ({
  type: `${GET_REPORTS_ACCESS_LIST}${START}`,
})

export const getReportsAccessListSuccess = data => ({
  type: `${GET_REPORTS_ACCESS_LIST}${SUCCESS}`,
  payload: data,
})

export const getReportsAccessListError = data => ({
  type: `${GET_REPORTS_ACCESS_LIST}${ERROR}`,
  payload: data,
})

// SAGAS

export function* authWatcher() {
  yield takeLatest(`${AUTH_REQUEST}${START}`, authWorker)
  yield takeLatest(`${RESET_AUTH_DATA}`, logoutWorker)
  yield takeLatest(`${CHECK_AUTH_REQUEST}${START}`, checkAuthWorker)
  yield takeLatest(`${GET_REPORTS_ACCESS_LIST}${START}`, getReportsAccessListWorker)
}

function* authWorker({ payload }) {
  yield put(startSubmit('login'))
  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      const res = yield call(authAPI.login, payload)
      const { Result, Message, Data, Code } = res.data.Answer
      if (Result === 'Error') {
        if (attempt === MAX_RETRIES || Code !== 'Database.ConnectionError') {
          NotificationManager.error(Message)
          yield put(stopSubmit('login'))
          return;
        } else continue;
      }
      const data = Data[0]
      yield put(authRequestSuccess(payload, data))
      yield put(stopSubmit('login'))
      const { login, pass } = yield select(({ auth }) => auth.data)
      yield put(getReportsAccessListStart())
      localStorage.setItem('login', login)
      localStorage.setItem('pass', pass)
      localStorage.setItem('fio', data.FIO)
      return
    } catch (error) {
        if (error.response) {
          yield put(authRequestError(error.response.data))
          const messageError = error.response.data.Answer.Message
          const message = messageError.length > 0 ? messageError : 'Возникла непредвиденная ошибка'
          yield put(stopSubmit('login', { _error: message }))
        }
    }
  }
}

function* logoutWorker() {
  localStorage.removeItem('login')
  localStorage.removeItem('pass')
  localStorage.removeItem('fio')
  localStorage.removeItem('reports_access')
  try {
    // yield call(authAPI.logout)
    yield put(resetAuthDataAction())
  } catch (e) {
    console.log(e)
  }
}

function* getReportsAccessListWorker() {
  try {
    const { login, pass } = yield select(({ auth }) => auth.data)
    const response = yield call(authAPI.getReportsAccess, { login, pass })
    const { Result, Data } = response.data.Answer
    if (Result === 'Error') {
      yield put(getReportsAccessListError('Не удалось получить список доступных отчетов'))
      return
    }
    const list = Data.map(i => i.name)
    yield put(getReportsAccessListSuccess(list))
    localStorage.setItem('reports_access', JSON.stringify(list))
  } catch (error) {
    console.error('Error fetching reports access list:', error)
    yield put(getReportsAccessListError(error))
  }
}

function* checkAuthWorker() {
  try {
    const response = yield call(authAPI.checkAuth)
    yield put(checkAuthRequestSuccess(response.data))
  } catch (error) {
    yield put(checkAuthRequestError(error))
  }
}

export const getAuthData = state => state.auth.data
export const getReportsAccess = state => state.auth.reports_access
